import firebase from 'firebase'

let config = {
  apiKey: "AIzaSyBIiEDP64xJXcsLH1t8mrjRtn9hPhQFem0",
  authDomain: "controlnewfangledtech.firebaseapp.com",
  databaseURL: "https://controlnewfangledtech.firebaseio.com",
  projectId: "controlnewfangledtech",
  storageBucket: "controlnewfangledtech.appspot.com",
  messagingSenderId: "921057439939",
  appId: "1:921057439939:web:fc07b83a00968c8eaab276",
  measurementId: "G-HCYGNG6NL3"
};
firebase.initializeApp(config);

export default {
  database: firebase.database()
}
